<template>
    <div class="data-table__item">
        <div>
            <h3>{{ schedule.property.street }} {{ schedule.property.housenumber ? schedule.property.housenumber : '' }} {{ schedule.property.housenumber_addition ? schedule.property.housenumber_addition : '' }}</h3>
            <p>{{ schedule.property.city }}</p>
        </div>

        <div class="data-table__item--centered">
            <p>Datum</p>
            <p>{{ schedule.dates | format }}</p>
        </div>

        <div class="data-table__item--centered">
            <p>Type</p>
            <p>{{ schedule.type | type }}</p>
        </div>

        <div>
            <ul class="data-table__options">
                <router-link v-if="type === 'start'" :to="{ name: 'inspectionStart', params: { scheduleID: schedule.id, projectID: schedule.property.project_id, propertyID: schedule.property.id } }" active-class="active">
                    Opname uitvoeren
                </router-link>

                <router-link v-if="type === 'edit'" v-show="inspectionID !== 0" :to="{ name: 'inspectionEdit', params: { scheduleID: schedule.id, projectID: schedule.property.project_id, propertyID: schedule.property.id, inspectionID: this.inspectionID } }" active-class="active">
                    Opname openen
                </router-link>

                <router-link v-if="type === 'show'"  :to="{ name: 'onlineDossier', params: { token: schedule.property.token } }" target="_blank">
                    Online dossier
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import moment from 'moment'
	import { FETCH_INSPECTIONS } from '@/store/modules/inspections'

	export default {
		props: ['schedule', 'type'],

		methods: {
			fetchLastInspection () {
				this.$store.dispatch(FETCH_INSPECTIONS, { property: this.schedule.property.id }).then((response) => {
					this.inspectionID = response[response.length - 1].id
				})
			},
		},

		data () {
			return {
				inspectionID: 0,
			}
		},

		computed: {
			...mapGetters([
				'currentUser',
			]),
		},

		mounted () {
			console.log( this.type );
			console.log(this.schedule)

			if (this.type === 'edit' || this.type === 'view') {
				this.fetchLastInspection()
			}
		},

		filters: {
			format (value) {
				moment.locale('nl')
				let inspectionDates = []

				value.map((date) => {
					inspectionDates.push(moment(date.date).format('LL'))
				})

				return inspectionDates.join(', ')
			},

			type (value) {
				if (value === 1) {
					return 'Vooropname'
				}
				if (value === 2) {
					return 'Tussenopname'
				}
				if (value === 3) {
					return 'Extra opname'
				}
				if (value === 4) {
					return 'Eindopname'
				}
			},
		},
	}
</script>
